import React from 'react';
import './FooterBar.scss';

export default function FooterBar(props) {
  const { subTotal, price, selectedIndex, currencySymbol } = props;
  return (
    <div className={`footer-div ${selectedIndex === 2 ? 'bottomInc' : ''}`}>
      <div className="subtotal">
        <span className="subtext">
          {subTotal}
          <span className="frametext">{' (Frame + Lens): '}</span>
        </span>
        <span className="pricetotal">
          {currencySymbol}
          {price}
        </span>
      </div>
      {!props.showPackagesModal && props.children}
    </div>
  );
}
